var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-ticket-wrapper",
    {
      attrs: { ticket: _vm.ticket, "base-path": _vm.basePath },
      on: {
        files: function ($event) {
          return _vm.addFiles($event)
        },
        update: function ($event) {
          return _vm.update()
        },
      },
    },
    [
      _c("app-chat-messages", { attrs: { value: _vm.messages } }),
      _c("app-message-input", {
        attrs: {
          "is-sending": _vm.isSending,
          "long-messages": "",
          files: _vm.files,
        },
        on: {
          send: function ($event) {
            return _vm.sendMessage()
          },
          file: function ($event) {
            return _vm.addFiles([$event])
          },
        },
        model: {
          value: _vm.messageInput,
          callback: function ($$v) {
            _vm.messageInput = $$v
          },
          expression: "messageInput",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }